/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import type { Session } from "../ClientContext";

// Keep the same Matrix account, device and access token; remove only obsolete registration state.
export function persistentStaffSession(
  session: Session,
  userId: string,
  accessToken: string | null,
): Session | null {
  if (
    session.user_id !== userId ||
    !accessToken ||
    session.access_token !== accessToken
  )
    return null;
  const updated = { ...session, passwordlessUser: false };
  delete updated.tempPassword;
  return updated;
}
